var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.594 226.594L44.596 34.594C40.537 32.848 36.26 32 32.019 32C23.396 32 14.922 35.5 8.721 42.047C-0.498 51.812 -2.623 66.297 3.377 78.312L96 256L3.377 433.688C-2.623 445.703 -0.498 460.188 8.721 469.953C14.908 476.5 23.377 480 32.002 480C36.252 480 40.533 479.156 44.596 477.406L492.594 285.406C504.375 280.375 512 268.797 512 256S504.375 231.625 492.594 226.594ZM66.92 96.383L383.355 232H137.619L66.92 96.383ZM137.619 280H383.355L66.93 415.613L137.619 280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTop);
export default __webpack_public_path__ + "static/media/paper-plane-top.879647a33ac5de5400ad830d9fe1381f.svg";
export { ForwardRef as ReactComponent };